import React, { Fragment } from "react";
import Nav from "../../components/NavBar/Nav";
import Footer from "../../components/Footer/Footer";
import SearchPhoto from "../../components/SearchPhoto/SearchPhoto";

const GetPhoto = () => {
  return (
    <Fragment>
      <Nav />
      <SearchPhoto />
      <Footer />
    </Fragment>
  );
};

export default GetPhoto;
